import React, { useCallback } from 'react';
import { useLocation } from 'react-router-dom';
import { Button, Card, Layout, notification, Typography } from 'antd';
import qs from 'query-string';
import { getAuth } from '../../config';

import { ReactComponent as iftt } from '../../assets/iftt.svg';
import callHttpsFunction from '../../utils/functions';

export default function AuthorizeIFTTT() {
  const location = useLocation();
  const { uid, email } = getAuth().currentUser;

  const authorize = useCallback(async () => {
    const params = qs.parse(location.search);
    const { state, redirect_uri: redirectUri = '', client_id: clientId, scope } = params;

    try {
      const { result } = await callHttpsFunction('iftttOAuth2AuthorizeUser', {
        client_id: clientId,
        state,
        scope,
      });

      window.location = `${redirectUri}?code=${result.code}&state=${state}`;
    } catch (e) {
      notification.error({ message: 'Errore nel generare il token' });
    }
  }, [location, uid]);

  return (
    <Layout style={{ minHeight: '100vh' }}>
      <Layout.Content style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
        <Card style={{ maxWidth: '40em', margin: 20 }}>
          <img
            src={iftt}
            alt="iftt logo"
            style={{ maxWidth: '10rem', margin: 'auto', display: 'block' }}
          />
          <Typography.Title level={4} style={{ marginTop: '2rem' }}>
            Vuoi collegare il tuo account con IFTTT
          </Typography.Title>
          <div align="center">Sei collegato come {email}</div>
          <div style={{ marginTop: '1rem' }}>
            <Button type="primary" onClick={authorize} style={{ margin: 'auto', display: 'block' }}>
              Autorizza IFTTT
            </Button>
          </div>
        </Card>
      </Layout.Content>
    </Layout>
  );
}
